import { BprRejectInfo, Notification } from "../../local_modules/voy-fleet-sub-view/src/types";
import { NotificationType } from "../services/types/fleet-notification-service.types";
import { AuditLog } from "../services/types/fleet-weather-routing-notification.types";
import { BaseModel } from "./base-model";
import { VoyagePlan } from "./vessel-planning-model";

let VoyFleetNotificationModel: VoyFleetNotificationModelBase|null = null;

export enum NotificationEvents {
    OfflineNotificationsUpdated = "offline-notifications-updated",
}

function setVoyFleetNotificationModel(model: VoyFleetNotificationModelBase)
{
    VoyFleetNotificationModel = model;
}

export abstract class VoyFleetNotificationModelBase extends BaseModel {
    public abstract getVesselNotificationLog(imo: number,type: string):    Promise<NotificationType[] | undefined>
    public abstract postFeedback(ipayload:any):  Promise<any| undefined>
    public abstract getFeedbackSubmittedHistory():  Promise<any| undefined>
    public abstract getBprInformationNotification(imo: number):  NotificationType[] | undefined
    public abstract fetchBprInformationNotification(imo: number, type: string): Promise<Notification[] | undefined>
    public abstract getFilteredBprInformation(imo: number, plan: VoyagePlan | undefined): BprRejectInfo | null
    public abstract getBprRejectLog(type: string): Promise<any| undefined>
    public abstract updateNotification(notificationId: string, payload:any, type?: string):  Promise<any| undefined>
    public abstract getWeatherRoutingNotifications(imo?: number): Promise<AuditLog[] | undefined>;
    public abstract updateWeatherRoutingNotifications(payload: any): Promise<any | undefined>;
    public abstract fetchOfflineVesselNotifications(): Promise<void>;
    public abstract get offlineVesselNotifications(): NotificationType[];

}

export { VoyFleetNotificationModel, setVoyFleetNotificationModel };
